import(/* webpackMode: "eager", webpackExports: ["ObfuscatedEmail"] */ "/app/components/ObfuscatedEmail/ObfuscatedEmail.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Button"] */ "/app/node_modules/@mantine/core/esm/components/Button/Button.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["Container"] */ "/app/node_modules/@mantine/core/esm/components/Container/Container.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mantine/core/esm/components/Text/Text.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["Box"] */ "/app/node_modules/@mantine/core/esm/core/Box/Box.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
